import SecondaryMarketTable from './secondary-market-table';

export default SecondaryMarketTable;
